import {Flex} from "@chakra-ui/react";

import CheckIcon from "@/assets/svg/check-icon.svg";

const DefaultCheckbox = ({checkHandler, checked = true, text, checkbox}) => {
    return (
        <Flex
            columnGap={"4px"}
            {...checkbox}
            cursor={"pointer"}
            onClick={checkHandler}
        >
            <Flex
                minW={"15px"}
                minH={"15px"}
                borderWidth={"0.75px"}
                borderColor={"mainBlue"}
                borderRadius={"4px"}
                alignItems={"center"}
                justifyContent={"center"}
                pe={"0.5px"}
            >
                {checked ? <CheckIcon/> : null}
            </Flex>
            <Flex
                w={"100%"}
                maxH={"15px"}
                fontSize={"12px"}
                color={"mainBlue"}
                alignSelf={"end"}
                lineHeight={"1"}
            >
                {text}
            </Flex>
        </Flex>
    );
};

export default DefaultCheckbox;
